<template>
<Moveable :draggable="false" :resizable="false" class="moveable">        
    <span>Vue Moveable</span>
    <input type="text" name="" value="textfield value"/>  
</Moveable>
</template>
<script>
import Moveable from 'vue-moveable';

export default {
  name: 'app',
  components: {
    Moveable,
  },
  data: () => ({

  }),
  methods: {

  }
}
</script>

<style>
.moveable {
    position: fixed;      
    width: 100px;
    height: 200px;
    z-index:4000;

}
</style>